import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const AdMedias = {
  List: lazyNamed(() => import('./containers/AdMediasList/index.tsx'), 'AdMediasList'),
  AdMediaHistory: lazyNamed(() => import('./containers/AdMediaHistory.tsx'), 'AdMediaHistory'),
};
